
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import DialogContent from '@/components/base/DialogContent.vue';
import ActionsIsland from '@/components/ActionsIsland.vue';
import { SNACKBAR_STATUS } from '@/constants/constants';
import { functions } from '@/firebase';
import _trim from 'lodash/trim';
import CompanyBalanceRecordsHistory from './CompanyBalanceRecordsHistory.vue';
import NumberWithIncrementer from '@/components/base/NumberWithIncrementer.vue';
import NewRecordForCompanyBankBtn from './NewRecordForCompanyBankBtn.vue';
import {
	RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT,
	RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT_MIN_QTY,
	RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT_MAX_QTY,
	RUNNIT_TOKENS_PRICE_QUOTE_QTY,
	getRunnitTokensOveragePrice,
	getRunnitTokensPackageEnterprisePrice,
	getRunnitTokensPrePurchasePrice,
} from '@run-diffusion/shared';
import TokensSVG from '@/assets/TokensSVG.vue';

export default Vue.extend({
	name: 'PrePurchaseRunnitTokensBtn',
	data () {
		return {
			RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT_MIN_QTY,
			RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT_MAX_QTY,
			RUNNIT_TOKENS_PRICE_QUOTE_QTY,
			showDialog: false,
			qty: RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT_MIN_QTY,
			loading: false,
			note: '',
			confirmText: '',

			windowView: 0,
			PURCHASE_TOKENS_WINDOW_ITEM: 0,
			BALANCE_HISTORY_WINDOW_ITEM: 1,

			companyBalanceRecordsHistoryRefreshIncrementer: 0,
		};
	},
	created () {
		this.resetValues();
	},
	computed: {
		...mapState([
			'team',
			'user',
		]),
		...mapGetters([
			'displayLabels',
			'companyClubOfferBenefits',
		]),
		// Per-company negotiated rates live on the Company doc, falling back to the defaults
		prePurchasePrice () {
			return getRunnitTokensPrePurchasePrice(this.team && this.team.company);
		},
		overagePrice () {
			return getRunnitTokensOveragePrice(this.team && this.team.company);
		},
		totalTokens () {
			return Math.round(RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT * this.qty);
		},
		totalCost () {
			const packagePrice: number = getRunnitTokensPackageEnterprisePrice(this.team && this.team.company);
			return Math.round(packagePrice * this.qty);
		},
		isConfirmed () {
			return (this.confirmText || '').toLowerCase() === 'i agree';
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		onShowDialogInput (val: boolean) {
			this.showDialog = !!val;
			if (!this.companyClubOfferBenefits.isEnterprise) {
				this.$nextTick(() => {
					this.showDialog = false;
				});
			}
		},
		resetValues () {
			this.qty = RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT_MIN_QTY;
			this.note = '';
			this.confirmText = '';
		},
		async handlePrePurchaseConfirm () {
			if (!this.companyClubOfferBenefits.isEnterprise) return;

			this.loading = true;

			try {
				const trimmedNote: string = _trim(this.note);
				const functionRef = functions
					.httpsCallable('prePurchaseCompanyRunnitTokens');
				const { success, message } = (await functionRef({
					teamId: this.team.id,
					quantity: this.qty || RUNNIT_TOKENS_PACKAGE_ENTERPRISE_AMOUNT_MIN_QTY,
					...(trimmedNote && { note: trimmedNote }),
				})).data;

				if (success) {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.SUCCESS,
						message: 'Tokens order submitted successfully!',
						show: true,
					});
					this.resetValues();

					// Auto-select and refresh the history tab after successful purchase
					this.windowView = this.BALANCE_HISTORY_WINDOW_ITEM;
					this.companyBalanceRecordsHistoryRefreshIncrementer++;
				} else {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.ERROR,
						message: message || 'Failed to submit tokens order',
						timeout: 10000,
						show: true,
					});
				}
			} catch (e) {
				console.error(e);
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'An error occurred while submitting tokens order',
					show: true,
				});
			} finally {
				this.loading = false;
			}
		},
		onNewRecordCreated () {
			// Refresh the history when a new record is created
			this.companyBalanceRecordsHistoryRefreshIncrementer++;
		},
		handleNewRecordClick () {
			console.log('handleNewRecordClick');
		}
	},
	components: {
		TokensSVG,
		NumberWithIncrementer,
		DialogOrBottomSheet,
		DialogContent,
		ActionsIsland,
		CompanyBalanceRecordsHistory,
		NewRecordForCompanyBankBtn,
	},
});
